import { StoreState } from '../../types/store';
import {
    NeOnboardingCloseTrackingLabels,
    NewOnBoardingTrackingActions,
    NewOnBoardingTrackingLabels,
    OnboardingState,
} from './types';

import {
    getOnboardingCurrentState,
    getOnboardingStateStack,
} from '../../selectors/onboarding.selectors';

import { isClientRendering } from '../../lib/helpers';

import { getLocalStorageItem, setLocalStorageItem } from '../../lib/webStorage';
import eventTracking from '../../services/analytics/eventTracking';
import {
    ALL_ONBOARDING_STEP_LIST,
    INIT_ON_BOARDING_STEP_HISTORY,
    WS_KEY_CURRENT_ON_BOARDING_STEP,
    WS_KEY_ON_BOARDING_STEP_HISTORY,
} from './constants';

export const trackNewOnBoardingAction = (
    action: NewOnBoardingTrackingActions,
    label?: NewOnBoardingTrackingLabels,
) => {
    eventTracking.sendEvent('Onboarding-no-docs-new', action, label);
};

export const onBoardingStateToCloseOnBoardingLabelMap: Partial<
    Record<OnboardingState, NeOnboardingCloseTrackingLabels | string>
> = {
    START_WORK: 'Main-page',
    INVITE_BANNER: 'Invite-page',
    UPLOAD_WEB_BANNER: 'Upload-page',
    CHECK_USERS_BANNER: 'Check-contractor-page',
};

export const persistStateToStorageEffect = (state: StoreState) => {
    setLocalStorageItem(
        WS_KEY_CURRENT_ON_BOARDING_STEP,
        getOnboardingCurrentState(state),
    );
    setLocalStorageItem(
        WS_KEY_ON_BOARDING_STEP_HISTORY,
        getOnboardingStateStack(state),
    );
};

export const isOnboardingStateGuard = (step: string): step is OnboardingState =>
    ALL_ONBOARDING_STEP_LIST.includes(step as OnboardingState);

export const initializeOnBoardingCurrentState = () => {
    if (!isClientRendering()) {
        return INIT_ON_BOARDING_STEP_HISTORY[0];
    }

    const persistStep = getLocalStorageItem(WS_KEY_CURRENT_ON_BOARDING_STEP);

    return isOnboardingStateGuard(persistStep)
        ? persistStep
        : INIT_ON_BOARDING_STEP_HISTORY[0];
};

export const initializeOnBoardingStateStack = () => {
    if (!isClientRendering()) {
        return INIT_ON_BOARDING_STEP_HISTORY;
    }

    const persistStepHistory = getLocalStorageItem(
        WS_KEY_ON_BOARDING_STEP_HISTORY,
    );

    if (
        Array.isArray(persistStepHistory) &&
        persistStepHistory.every(isOnboardingStateGuard)
    ) {
        return persistStepHistory;
    }

    return INIT_ON_BOARDING_STEP_HISTORY;
};
